import axios from 'axios'
import { setupAuthInterceptor } from '@/lib/authInterceptor'

export const LEXICAL_API_BASE_URL =
  import.meta.env.VITE_LEXICAL_API_BASE_URL || 'https://english-lexical-api.hocnhe.com'

export const lexicalAdminAxios = axios.create({
  baseURL: `${LEXICAL_API_BASE_URL}/v1/admin`,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
})

setupAuthInterceptor(lexicalAdminAxios)

export interface ApiEnvelope<T> {
  success: boolean
  code: number
  messageCode: string
  message: string
  data?: T
  pagination?: {
    page: number
    size: number
    total: number
  }
}

export class ApiResponseError extends Error {
  readonly envelope: ApiEnvelope<unknown>

  constructor(envelope: ApiEnvelope<unknown>, fallback: string) {
    super(apiErrorMessage(envelope, fallback))
    this.name = 'ApiResponseError'
    this.envelope = envelope
  }
}

export function requireApiData<T>(response: ApiEnvelope<T>, fallback: string): T {
  if (!response.success || response.data === undefined) {
    throw new ApiResponseError(response, fallback)
  }
  return response.data
}

export function requireApiSuccess<T>(response: ApiEnvelope<T>, fallback: string): ApiEnvelope<T> {
  if (!response.success) throw new ApiResponseError(response, fallback)
  return response
}

function apiErrorMessage(response: ApiEnvelope<unknown>, fallback: string): string {
  if (typeof response.data === 'string' && response.data.trim()) return response.data
  if (typeof response.data === 'object' && response.data !== null) {
    const detail = response.data as { errors?: unknown; message?: unknown }
    if (typeof detail.message === 'string' && detail.message.trim()) return detail.message
    const errors = detail.errors
    if (Array.isArray(errors) && errors.every((item) => typeof item === 'string')) {
      return errors.join('\n')
    }
  }
  return response.message || fallback
}
